import { createFileRoute } from '@tanstack/react-router'
import { StudentListsPage } from '@features/student-lists/components/StudentListsPage'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students/lists')({
  component: RouteComponent,
  beforeLoad: requireRouteAudience(['staff']),
  staticData: { crumb: { label: 'Student lists' } },
})

function RouteComponent() {
  return <StudentListsPage />
}
